/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetManagementHistoryInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetManagementHistoryOkDto } from '../../src/model';
// @ts-ignore
import type { AdminManagementHistoryResponse } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminManagementHistoryApi - axios parameter creator
 * @export
 */
export const AdminManagementHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 관리 이력 리스트 조회 API
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [keyword] 검색어(관리 이력 내용)
         * @param {AdminManagementHistoryAdminUserBehaviorCategoryEnum} [adminUserBehaviorCategory] 어드민 유저 행동 카테고리
         * @param {string} [adminUserName] 관리자 이름
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminManagementHistory: async (page?: number, limit?: number, keyword?: string, adminUserBehaviorCategory?: AdminManagementHistoryAdminUserBehaviorCategoryEnum, adminUserName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/management-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (adminUserBehaviorCategory !== undefined) {
                localVarQueryParameter['adminUserBehaviorCategory'] = adminUserBehaviorCategory;
            }

            if (adminUserName !== undefined) {
                localVarQueryParameter['adminUserName'] = adminUserName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리 이력 리스트 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [keyword] 검색어(관리 이력 내용)
         * @param {AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum} [adminUserBehaviorCategory] 어드민 유저 행동 카테고리
         * @param {string} [adminUserName] 관리자 이름
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminManagementHistoryControllerGetAdminManagementHistory: async (page?: number, limit?: number, keyword?: string, adminUserBehaviorCategory?: AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum, adminUserName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/management-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (adminUserBehaviorCategory !== undefined) {
                localVarQueryParameter['adminUserBehaviorCategory'] = adminUserBehaviorCategory;
            }

            if (adminUserName !== undefined) {
                localVarQueryParameter['adminUserName'] = adminUserName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminManagementHistoryApi - functional programming interface
 * @export
 */
export const AdminManagementHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminManagementHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 관리 이력 리스트 조회 API
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [keyword] 검색어(관리 이력 내용)
         * @param {AdminManagementHistoryAdminUserBehaviorCategoryEnum} [adminUserBehaviorCategory] 어드민 유저 행동 카테고리
         * @param {string} [adminUserName] 관리자 이름
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminManagementHistory(page?: number, limit?: number, keyword?: string, adminUserBehaviorCategory?: AdminManagementHistoryAdminUserBehaviorCategoryEnum, adminUserName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminManagementHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminManagementHistory(page, limit, keyword, adminUserBehaviorCategory, adminUserName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementHistoryApi.adminManagementHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리 이력 리스트 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [keyword] 검색어(관리 이력 내용)
         * @param {AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum} [adminUserBehaviorCategory] 어드민 유저 행동 카테고리
         * @param {string} [adminUserName] 관리자 이름
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async adminManagementHistoryControllerGetAdminManagementHistory(page?: number, limit?: number, keyword?: string, adminUserBehaviorCategory?: AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum, adminUserName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetManagementHistoryOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminManagementHistoryControllerGetAdminManagementHistory(page, limit, keyword, adminUserBehaviorCategory, adminUserName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminManagementHistoryApi.adminManagementHistoryControllerGetAdminManagementHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminManagementHistoryApi - factory interface
 * @export
 */
export const AdminManagementHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminManagementHistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary 관리 이력 리스트 조회 API
         * @param {AdminManagementHistoryApiAdminManagementHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminManagementHistory(requestParameters: AdminManagementHistoryApiAdminManagementHistoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminManagementHistoryResponse> {
            return localVarFp.adminManagementHistory(requestParameters.page, requestParameters.limit, requestParameters.keyword, requestParameters.adminUserBehaviorCategory, requestParameters.adminUserName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리 이력 리스트 조회
         * @param {AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        adminManagementHistoryControllerGetAdminManagementHistory(requestParameters: AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetManagementHistoryOkDto> {
            return localVarFp.adminManagementHistoryControllerGetAdminManagementHistory(requestParameters.page, requestParameters.limit, requestParameters.keyword, requestParameters.adminUserBehaviorCategory, requestParameters.adminUserName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminManagementHistory operation in AdminManagementHistoryApi.
 * @export
 * @interface AdminManagementHistoryApiAdminManagementHistoryRequest
 */
export interface AdminManagementHistoryApiAdminManagementHistoryRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminManagementHistoryApiAdminManagementHistory
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminManagementHistoryApiAdminManagementHistory
     */
    readonly limit?: number

    /**
     * 검색어(관리 이력 내용)
     * @type {string}
     * @memberof AdminManagementHistoryApiAdminManagementHistory
     */
    readonly keyword?: string

    /**
     * 어드민 유저 행동 카테고리
     * @type {'viewupAccountManagement' | 'viewupPlusAccountManagement' | 'userManagement' | 'exchangeManagement' | 'supporterAccountManagement' | 'postManagement' | 'viewPeopleManagement' | 'dashboardManagement' | 'notificationManagement' | 'reportManagement'}
     * @memberof AdminManagementHistoryApiAdminManagementHistory
     */
    readonly adminUserBehaviorCategory?: AdminManagementHistoryAdminUserBehaviorCategoryEnum

    /**
     * 관리자 이름
     * @type {string}
     * @memberof AdminManagementHistoryApiAdminManagementHistory
     */
    readonly adminUserName?: string
}

/**
 * Request parameters for adminManagementHistoryControllerGetAdminManagementHistory operation in AdminManagementHistoryApi.
 * @export
 * @interface AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistoryRequest
 */
export interface AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistoryRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistory
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistory
     */
    readonly limit?: number

    /**
     * 검색어(관리 이력 내용)
     * @type {string}
     * @memberof AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistory
     */
    readonly keyword?: string

    /**
     * 어드민 유저 행동 카테고리
     * @type {'viewupAccountManagement' | 'viewupPlusAccountManagement' | 'userManagement' | 'exchangeManagement' | 'supporterAccountManagement' | 'postManagement' | 'viewPeopleManagement' | 'dashboardManagement' | 'notificationManagement' | 'reportManagement'}
     * @memberof AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistory
     */
    readonly adminUserBehaviorCategory?: AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum

    /**
     * 관리자 이름
     * @type {string}
     * @memberof AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistory
     */
    readonly adminUserName?: string
}

/**
 * AdminManagementHistoryApi - object-oriented interface
 * @export
 * @class AdminManagementHistoryApi
 * @extends {BaseAPI}
 */
export class AdminManagementHistoryApi extends BaseAPI {
    /**
     * 
     * @summary 관리 이력 리스트 조회 API
     * @param {AdminManagementHistoryApiAdminManagementHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagementHistoryApi
     */
    public adminManagementHistory(requestParameters: AdminManagementHistoryApiAdminManagementHistoryRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminManagementHistoryApiFp(this.configuration).adminManagementHistory(requestParameters.page, requestParameters.limit, requestParameters.keyword, requestParameters.adminUserBehaviorCategory, requestParameters.adminUserName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리 이력 리스트 조회
     * @param {AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminManagementHistoryApi
     */
    public adminManagementHistoryControllerGetAdminManagementHistory(requestParameters: AdminManagementHistoryApiAdminManagementHistoryControllerGetAdminManagementHistoryRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminManagementHistoryApiFp(this.configuration).adminManagementHistoryControllerGetAdminManagementHistory(requestParameters.page, requestParameters.limit, requestParameters.keyword, requestParameters.adminUserBehaviorCategory, requestParameters.adminUserName, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminManagementHistoryAdminUserBehaviorCategoryEnum = {
    ViewupAccountManagement: 'viewupAccountManagement',
    ViewupPlusAccountManagement: 'viewupPlusAccountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    SupporterAccountManagement: 'supporterAccountManagement',
    PostManagement: 'postManagement',
    ViewPeopleManagement: 'viewPeopleManagement',
    DashboardManagement: 'dashboardManagement',
    NotificationManagement: 'notificationManagement',
    ReportManagement: 'reportManagement'
} as const;
export type AdminManagementHistoryAdminUserBehaviorCategoryEnum = typeof AdminManagementHistoryAdminUserBehaviorCategoryEnum[keyof typeof AdminManagementHistoryAdminUserBehaviorCategoryEnum];
/**
 * @export
 */
export const AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum = {
    ViewupAccountManagement: 'viewupAccountManagement',
    ViewupPlusAccountManagement: 'viewupPlusAccountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    SupporterAccountManagement: 'supporterAccountManagement',
    PostManagement: 'postManagement',
    ViewPeopleManagement: 'viewPeopleManagement',
    DashboardManagement: 'dashboardManagement',
    NotificationManagement: 'notificationManagement',
    ReportManagement: 'reportManagement'
} as const;
export type AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum = typeof AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum[keyof typeof AdminManagementHistoryControllerGetAdminManagementHistoryAdminUserBehaviorCategoryEnum];
